<template>
  <div v-loading="registration.loading == registrationFormId" style="min-height:400px;">
    <div id="dashboard-registration" v-if="registrationFormData != null">
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item, index) in registrationFormData.cards" :key="index">
          <div class="data-card purple">
            <div class="card-info">
              <div class="title">
                <span>{{ item.title }}</span>
              </div>
              <div class="value">
                <span>{{ item.value }}</span>
              </div>
              <div class="description">
                <span>{{ item.description }}</span>
              </div>
            </div>
            <div class="card-icon">
              <i :class="item.icon"></i>
            </div>
          </div>
        </el-col>
      </el-row>

      <div class="statistics-container">
        <div class="overview-table-header">
          <h3>{{ $t("components.dashboard.registration.paymentAnalysis") }}</h3>
          <!-- <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
            <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
          </el-tooltip> -->
        </div>

        <el-row :gutter="20">
          <el-col :span="16" class="pie-chart-container">
            <upgrade-overlay position="absolute" lottieWidth="150px" v-if="false"></upgrade-overlay>

            <el-table :data="registrationFormData.paymentAnalystics.slice(0, paymentAnalysticsSlicer)" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.paymentType')" min-width="180">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.title }}</b>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.today')" width="100">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.todayCount }}</b>
                    {{ $t("components.dashboard.registration.piece") }}
                  </span>
                  <span>
                    <b>{{ $currency.format(scope.row.todayBalance, { code: $enums.currency.find(x => x.value == registrationFormData.currency).title }) }}</b>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.last1')" width="100">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.last1MonthCount }}</b>
                    {{ $t("components.dashboard.registration.piece") }}
                  </span>
                  <span>
                    <b>{{ $currency.format(scope.row.last1MonthBalance, { code: $enums.currency.find(x => x.value == registrationFormData.currency).title }) }}</b>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.last3')" width="100">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.last3MonthCount }}</b>
                    {{ $t("components.dashboard.registration.piece") }}
                  </span>
                  <span>
                    <b>{{ $currency.format(scope.row.last3MonthBalance, { code: $enums.currency.find(x => x.value == registrationFormData.currency).title }) }}</b>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.allTime')" width="100" fixed="right">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.count }}</b>
                    {{ $t("components.dashboard.registration.piece") }}
                  </span>
                  <span>
                    <b>{{ $currency.format(scope.row.balance, { code: $enums.currency.find(x => x.value == registrationFormData.currency).title }) }}</b>
                  </span>
                </template>
              </el-table-column>
            </el-table>

            <div class="show-all" v-if="registrationFormData.paymentAnalystics.length > 5">
              <el-button size="mini" @click="showAllPaymentAnalystics()" round>{{ paymentAnalysticsSlicer > 5 ? $t("components.dashboard.registration.seeLess") : $t("components.dashboard.registration.seeAll") }}</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pie-chart-container">
              <div ref="paymentstatistics-chart" id="paymentstatistics-chart" class="chart"></div>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="statistics-container mt-3">
        <div class="overview-table-header">
          <h3>{{ $t("components.dashboard.registration.packages") }}</h3>
          <!-- <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
            <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
          </el-tooltip> -->
        </div>

        <el-row :gutter="20">
          <el-col :span="16">
            <el-table :data="registrationFormData.packetStatistics.slice(0, packetStatisticsSlicer)" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.package')" min-width="180">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.title }}</b>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.stockUsage')" width="120">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.stock }}</b>
                    / {{ scope.row.usage }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.amount')" width="100">
                <template slot-scope="scope">
                  <span>
                    <b>{{ $currency.format(scope.row.balance, { code: $enums.currency.find(x => x.value == registrationFormData.currency).title }) }}</b>
                  </span>
                </template>
              </el-table-column>
              <el-table-column type="expand">
                <template slot-scope="props">
                  <div v-for="(item, index) in props.row.priceOptions" :key="index">
                    <span>
                      <b>{{ item.title }}</b>
                    </span>
                    <span>
                      <b>{{ item.count }}</b>
                      {{ $t("components.dashboard.registration.piece") }}
                    </span>
                    <span>
                      <b>{{ $currency.format(item.balance, { code: $enums.currency.find(x => x.value == registrationFormData.currency).title }) }}</b>
                    </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <div class="show-all" v-if="registrationFormData.packetStatistics.length > 5">
              <el-button size="mini" @click="showAllPacketStatistics()" round>{{ packetStatisticsSlicer > 5 ? $t("components.dashboard.registration.seeLess") : $t("components.dashboard.registration.seeAll") }}</el-button>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pie-chart-container">
              <div ref="packetstatistics-chart" id="packetstatistics-chart" class="chart"></div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- <div class="statistics-container mt-3">
      <div class="overview-table-header">
        <h3>{{ $t("components.dashboard.registration.additionalServices") }}</h3>
        <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
          <el-button icon="fas fa-download" size="mini" @click="downloadReport(20)"></el-button>
        </el-tooltip>
      </div>

      <el-row :gutter="20">
        <el-col :span="24">
          <el-table :data="registrationFormData.additionalServices.slice(0, additionalServicesSlicer)" style="width: 100%">
            <el-table-column label="" width="38">
              <template slot-scope="scope">
                <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.dashboard.registration.service')" min-width="180">
              <template slot-scope="scope">
                <span
                  ><b>{{ scope.row.title }}</b></span
                >
              </template>
            </el-table-column>
            <el-table-column :label="$t('components.dashboard.registration.stockUsage')" width="120">
              <template slot-scope="scope">
                <span
                  ><b>{{ scope.row.stock }}</b> / {{ scope.row.usage }}</span
                >
              </template>
            </el-table-column>

            <el-table-column :label="$t('components.dashboard.registration.reminder')" width="120">
              <template slot-scope="scope">
                <span
                  ><b>{{ scope.row.stock - scope.row.usage }}</b></span
                >
              </template>
            </el-table-column>

            <el-table-column :label="$t('components.dashboard.registration.amount')" width="120">
              <template slot-scope="scope">
                <span
                  ><b>{{ $currency.format(scope.row.balance, { code: $enums.currency.find(x => x.value == registrationFormData.currency).title }) }}</b></span
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="show-all" v-if="registrationFormData.additionalServices.length > 5">
            <el-button size="mini" @click="showAllAdditionalServices()" round>{{ additionalServicesSlicer > 5 ? $t("components.dashboard.registration.seeLess") : $t("components.dashboard.registration.seeAll") }}</el-button>
          </div>
        </el-col>
      </el-row>
    </div> -->

      <div class="statistics-container mt-3">
        <div class="overview-table-header">
          <h3>{{ $t("components.dashboard.registration.couponCodes") }}</h3>
          <!-- <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
            <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
          </el-tooltip> -->
        </div>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-table :data="registrationFormData.couponGroups.slice(0, couponGroupsSlicer)" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.codeGroup')" min-width="180">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.title }}</b>
                  </span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.stockUsage')" width="120">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.stock }}</b>
                    / {{ scope.row.usage }}
                  </span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('components.dashboard.registration.reminder')" width="120">
                <template slot-scope="scope">
                  <span>
                    <b>{{ scope.row.stock - scope.row.usage }}</b>
                  </span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('components.dashboard.registration.totalDiscont')" width="120">
                <template slot-scope="scope">
                  <span>
                    <b>{{ $currency.format(scope.row.balance, { code: $enums.currency.find(x => x.value == registrationFormData.currency).title }) }}</b>
                  </span>
                </template>
              </el-table-column>
            </el-table>

            <div class="show-all" v-if="registrationFormData.couponGroups.length > 5">
              <el-button size="mini" @click="showAllCouponGroups()" round>{{ couponGroupsSlicer > 5 ? $t("components.dashboard.registration.seeLess") : $t("components.dashboard.registration.seeAll") }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="statistics-container mt-3">
        <div class="overview-table-header">
          <h3>{{ $t("components.dashboard.registration.expectedParticipation") }}</h3>
          <!-- <el-tooltip class="item" effect="dark" :content="$t('components.dashboard.content.reports')" placement="top">
            <el-button icon="fas fa-download" size="mini" @click="downloadReport"></el-button>
          </el-tooltip> -->
        </div>

        <el-row :gutter="20" class="pie-chart-container">
          <upgrade-overlay position="absolute" v-if="false" size="small" lottieWidth="150px"></upgrade-overlay>
          <el-col :span="24">
            <el-table :data="registrationFormData.dailyAttendings.slice(0, dailyAttendingsSlicer)" style="width: 100%">
              <el-table-column label="" width="38">
                <template slot-scope="scope">
                  <i class="fas fa-circle" :style="'color:' + scope.row.color"></i>
                </template>
              </el-table-column>
              <el-table-column :label="$t('components.dashboard.registration.day')" min-width="180">
                <template slot-scope="scope">
                  <span>
                    <b>{{ $moment(scope.row.date).format("Do MMM YY") + ", " + $moment(scope.row.date).format("hh:MM") }}</b>
                  </span>
                </template>
              </el-table-column>

              <template v-if="registrationFormData.dailyAttendings.length > 0">
                <el-table-column v-for="(item, index) in registrationFormData.dailyAttendings[0].attendings" :key="index" :fixed="index == registrationFormData.dailyAttendings[0].attendings.length - 1 ? 'right' : false" :label="item.title" width="150">
                  <template slot-scope="scope">
                    <span>
                      <b>{{ registrationFormData.dailyAttendings[scope.$index].attendings[index].count == null ? "-" : registrationFormData.dailyAttendings[scope.$index].attendings[index].count }}</b>
                    </span>
                  </template>
                </el-table-column>
              </template>
            </el-table>

            <div class="show-all" v-if="registrationFormData.dailyAttendings.length > 5">
              <el-button size="mini" @click="showAllDailyAttendings()" round>{{ dailyAttendingsSlicer > 5 ? $t("components.dashboard.registration.seeLess") : $t("components.dashboard.registration.seeAll") }}</el-button>
            </div>
          </el-col>
          <portal to="tab-refresh">
            <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
              <el-button type="success" size="mini" icon="fas fa-redo-alt" :loading="refreshLoading" @click="refreshData" round></el-button>
            </el-tooltip>
          </portal>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { C } from "caniuse-lite/data/agents";

export default {
  components: {},
  name: "Registration",
  props: ["registrationFormId"],
  data() {
    return {
      paymentAnalysticsPieChart: null,
      packetStatisticsPieChart: null,
      paymentAnalysticsSlicer: 5,
      packetStatisticsSlicer: 5,
      additionalServicesSlicer: 5,
      couponGroupsSlicer: 5,
      dailyAttendingsSlicer: 5,
      refreshLoading: false,
      timeout: null
    };
  },
  methods: {
    refreshData() {
      this.refreshLoading = true;
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getRegistration", { registrationFormId: this.registrationFormId });
        this.refreshLoading = false;
      }, 250);
    },
    downloadReport(type) {
      if (type == null || type == undefined) {
        return;
      } else {
        this.exportXlsx(type, this.registrationFormId, null);
      }
      // axios.post("report/generalstatistics", {}).then(res => {
      //   this.$message.success(res.data.alert.message)
      // })
    },

    showAllPaymentAnalystics() {
      if (this.paymentAnalysticsSlicer == 5) {
        this.paymentAnalysticsSlicer = 999999;
      } else if (this.paymentAnalysticsSlicer == 999999) {
        this.paymentAnalysticsSlicer = 5;
      }
    },

    showAllPacketStatistics() {
      if (this.packetStatisticsSlicer == 5) {
        this.packetStatisticsSlicer = 999999;
      } else if (this.packetStatisticsSlicer == 999999) {
        this.packetStatisticsSlicer = 5;
      }
    },

    showAllAdditionalServices() {
      if (this.additionalServicesSlicer == 5) {
        this.additionalServicesSlicer = 999999;
      } else if (this.additionalServicesSlicer == 999999) {
        this.additionalServicesSlicer = 5;
      }
    },

    showAllCouponGroups() {
      if (this.couponGroupsSlicer == 5) {
        this.couponGroupsSlicer = 999999;
      } else if (this.couponGroupsSlicer == 999999) {
        this.couponGroupsSlicer = 5;
      }
    },

    showAllDailyAttendings() {
      if (this.dailyAttendingsSlicer == 5) {
        this.dailyAttendingsSlicer = 999999;
      } else if (this.dailyAttendingsSlicer == 999999) {
        this.dailyAttendingsSlicer = 5;
      }
    },

    createPaymentAnalysticsPieChart() {
      var chart = am4core.create("paymentstatistics-chart", am4charts.PieChart);
      chart.data = this.registrationFormData.paymentAnalysticsChartData.datasets;
      chart.radius = am4core.percent(100);
      chart.hiddenState.properties.opacity = 0;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      chart.pieSeries = pieSeries;
      // chart.legend = new am4charts.Legend();
      // chart.legend.maxWidth = undefined;
      // chart.legend.valueLabels.template.align = "left";
      // chart.legend.valueLabels.template.textAlign = "end";
      chart.responsive.enabled = true;
      this.paymentAnalysticsPieChart = chart;
    },

    createPacketStatisticsPieChart() {
      var chart = am4core.create("packetstatistics-chart", am4charts.PieChart);
      chart.data = this.registrationFormData.packetStatisticsChartData.datasets;
      chart.radius = am4core.percent(100);
      chart.hiddenState.properties.opacity = 0;
      let pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "key";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;
      chart.pieSeries = pieSeries;
      // chart.legend = new am4charts.Legend();
      // chart.legend.maxWidth = undefined;
      // chart.legend.valueLabels.template.align = "left";
      // chart.legend.valueLabels.template.textAlign = "end";
      chart.responsive.enabled = true;
      this.packetStatisticsPieChart = chart;
    }
  },

  async mounted() {
    if (this.registrationFormData == null) {
      await this.$store.dispatch("getRegistration", { registrationFormId: this.registrationFormId });
      this.$nextTick(() => {
        this.createPaymentAnalysticsPieChart();
        this.createPacketStatisticsPieChart();
      });
    } else {
      if (this.paymentAnalysticsPieChart == null) {
        this.createPaymentAnalysticsPieChart();
      }
      if (this.packetStatisticsPieChart == null) {
        this.createPacketStatisticsPieChart();
      }
    }

    this.$watch("registration.loading", function() {
      this.paymentAnalysticsPieChart.data = this.registrationFormData.paymentAnalysticsChartData.datasets;
      this.packetStatisticsPieChart.data = this.registrationFormData.packetStatisticsChartData.datasets;
    });
  },

  computed: {
    eventPermissions() {
      return this.$store.getters.getEventPermission;
    },
    registration() {
      return this.$store.getters.getDashboardRegistration;
    },
    registrationFormData() {
      var data = this.$store.getters.getDashboardRegistrationForms.find(x => x.registrationFormId == this.registrationFormId);
      if (false) {
        if (data && data.dailyAttendings != null && data.dailyAttendings != undefined) {
          data.dailyAttendings = data.dailyAttendings.map(x => {
            x.attendings = x.attendings.map(y => {
              return {
                ...y,
                count: 0
              };
            });
            return x;
          });
        }
        if (data && data.paymentAnalystics != null && data.paymentAnalystics != undefined) {
          data.paymentAnalystics.map(x => {
            x.last1MonthBalance = Math.floor(Math.random() * 100) + 1;
            x.last1MonthCount = Math.floor(Math.random() * 100) + 1;
            x.last3MonthBalance = Math.floor(Math.random() * 100) + 1;
            x.last3MonthCount = Math.floor(Math.random() * 100) + 1;
            x.todayBalance = Math.floor(Math.random() * 100) + 1;
            x.todayCount = Math.floor(Math.random() * 100) + 1;
            x.balance = x.last1MonthBalance + x.last3MonthBalance + x.todayBalance;
            x.count = Math.floor(x.todayCount + x.last1MonthCount + x.last3MonthCount);
          });
          data.paymentAnalysticsChartData.datasets = data.paymentAnalysticsChartData.datasets.map(x => {
            x.value = Math.floor(Math.random() * 100) + 1;
            return x;
          });
        }
      }
      return data;
    }
  },

  beforeDestroy() {
    if (this.paymentAnalysticsPieChart) {
      this.paymentAnalysticsPieChart.dispose();
    }
    if (this.packetStatisticsPieChart) {
      this.packetStatisticsPieChart.dispose();
    }
  },

  watch: {}
};
</script>

<style lang="less">
#registration {
  .el-tabs__content {
    overflow: unset !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/Registration.vue